/* Registra el service worker y avisa cuando hay una nueva version disponible */
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  let refreshing = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register(`${process.env.BASE_URL}service-worker.js`);

      if (registration.waiting) {
        const shouldUpdateNow = window.confirm('Hay una nueva version disponible. Deseas actualizar ahora?');
        if (shouldUpdateNow) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      }

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          const isNewVersionReady = newWorker.state === 'installed' && navigator.serviceWorker.controller;
          if (!isNewVersionReady) return;

          const shouldUpdateNow = window.confirm('Hay una nueva version disponible. Deseas actualizar ahora?');
          if (shouldUpdateNow && registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          }
        });
      });
    } catch (error) {
      console.error('Error registrando service worker:', error);
    }
  });
}
